import request from '../utils/request'
import qs from 'qs'
import { commonConfig } from '../utils/config'
const { apiUrl, apiHetaoDomain } = commonConfig

// 获取订单管理列表
export async function getPromotionList (params) {
  return request(`${apiHetaoDomain}/ug-agent-back/v1/token/agent/position/list?${qs.stringify(params)}`)
}

export async function getMemberList (params) {
  return request(`${apiHetaoDomain}/ug-agent-back/v1/token/agent/team/composition?${qs.stringify(params)}`)
}

export async function addProduct (params) {
  return request(`${apiUrl}/ug-agent-back/v1/token/agent/info`, params)
}

export async function editProduct (params) {
  return request(`${apiUrl}/ug-agent-back/v1/token/agent/info`, params)
}

export async function getChannelList (teamCode) {
  return request(`${apiHetaoDomain}/ug-agent-back/v1/token/agent/channel/list?teamCode=${teamCode}`)
}

export async function modifyAdmin (params) {
  return request(`${apiUrl}/ug-agent-back/v1/token/agent/modifyAdmin`, params)
}
